let detectorPromise = null;

const MIN_CONFIDENCE = 0.9;
const MIN_FACE_WIDTH_RATIO = 0.15;

const loadDetector = () => {
  if (!detectorPromise) {
    detectorPromise = (async () => {
      const tf = await import("@tensorflow/tfjs-core");
      await import("@tensorflow/tfjs-backend-webgl");
      const blazeface = await import("@tensorflow-models/blazeface");
      await tf.setBackend("webgl");
      await tf.ready();
      return blazeface.load();
    })().catch((err) => {
      detectorPromise = null;
      throw err;
    });
  }
  return detectorPromise;
};

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("No se pudo leer la imagen")); };
  img.src = url;
});

export async function detectSingleFace(file) {
  const img = await loadImage(file);
  const model = await loadDetector();
  const faces = (await model.estimateFaces(img, false))
    .filter((f) => f.probability[0] >= MIN_CONFIDENCE);

  if (faces.length === 0)
    return { ok: false, message: "No detectamos un rostro humano. Usa una foto clara de tu cara, de frente y bien iluminada." };
  if (faces.length > 1)
    return { ok: false, message: "Se detectó más de una cara. La foto debe mostrar solo tu rostro." };

  const [x1] = faces[0].topLeft;
  const [x2] = faces[0].bottomRight;
  if ((x2 - x1) / img.width < MIN_FACE_WIDTH_RATIO)
    return { ok: false, message: "Tu rostro se ve muy pequeño. Acércate a la cámara para que tu cara ocupe más de la imagen." };

  return { ok: true };
}
